import { Shipment } from '@laco/backend-interfaces';
import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { generalPageStyles } from '../Styles/reactPDF';

const styles = StyleSheet.create({
  flexStartRow: {
    ...generalPageStyles.row,
    alignItems: 'flex-start',
    fontSize: 10,
  },
  alignmentAdjustment: {
    marginTop: -2,
  },
});

interface HitachiShippingLabelProps {
  shipmentLines: Shipment.ShipmentLine[];
  customerPO?: string;
  customerName?: string;
  packingList: string;
}

export const HitachiShippingLabel = (props: HitachiShippingLabelProps) => {
  const { shipmentLines, customerName, customerPO, packingList } = props;
  return (
    <Document
      title={`Shipping Label - ${packingList}`}
      subject={`Packing Label - ${packingList}`}
      author='LACO INC'
      creator='Traverse'
    >
      {shipmentLines.map((line, index) => (
        <Page
          key={index}
          orientation='landscape'
          size={{ width: 216, height: 288 }}
          style={generalPageStyles.labelPage}
        >
          <View>
            <View
              style={[
                generalPageStyles.row,
                {
                  justifyContent: 'space-around',
                  alignItems: 'flex-start',
                  paddingBottom: '10px',
                  paddingTop: '10px',
                },
              ]}
            >
              <Text style={{ flex: 2, textAlign: 'center', fontSize: 30 }}>HITACHI MMS</Text>
            </View>
            <View
              style={[
                generalPageStyles.row,
                { justifyContent: 'space-around', alignItems: 'flex-start', paddingBottom: '10px' },
              ]}
            >
              <Text style={{ flex: 2, textAlign: 'center', fontSize: 30 }}>HARNESS ASSY</Text>
            </View>
            <View
              style={[
                generalPageStyles.row,
                { justifyContent: 'space-around', alignItems: 'flex-start', paddingBottom: '10px' },
              ]}
            >
              <Text style={{ flex: 2, textAlign: 'center', fontSize: 30 }}>{`P/N ${line.customerProductCode}`}</Text>
            </View>
            <View
              style={[
                generalPageStyles.row,
                { justifyContent: 'space-around', alignItems: 'flex-start', paddingBottom: '10px' },
              ]}
            >
              <Text style={{ flex: 2, textAlign: 'center', fontSize: 30 }}>{`REV ${line.productRevision}`}</Text>
            </View>
          </View>
        </Page>
      ))}
    </Document>
  );
};
